import React from 'react'
import { Notification, NotificationGroup } from '@progress/kendo-react-notification'
import { Fade } from '@progress/kendo-react-animation'
import dataConstant from '../../constants/dataConstants'
import i18n from '../../i18n'

export class KendoNotification extends React.Component {
  render() {
    const { response, redirectURL, isPageRedirectAfterSuccess } = this.props

    let { isNotification } = this.props
    let notificationType = 'none'
    let notificationMessage = ''
    if (response) {
      if (response.Status === dataConstant.APIResponseStatus.Failure) {
        notificationType = 'error'
        notificationMessage = response.error
      }
      if (response.Status === dataConstant.APIResponseStatus.Success) {
        notificationType = 'success'
        if (typeof response?.description !== 'undefined') {
          notificationMessage = response.description
        } else if (typeof response?.Message !== 'undefined') {
          notificationMessage = response.Message
        }
      }
      if (response.Status === dataConstant.APIResponseStatus.Warning) {
        notificationType = 'warning'
        notificationMessage = response.description
      }
      if (response.Status === 'Info') {
        notificationType = 'info'
        notificationMessage = response.description
      }

      setTimeout(() => {
        isNotification = false
        if (response.Status === 'Success') {
          const { history } = this.props
          if (isPageRedirectAfterSuccess) {
            history.push(redirectURL)
          }
        }
      }, dataConstant.ToastNotificationTimeOut)
    }

    return (
      <div>
        <NotificationGroup
          style={{
            top: 0,
            right: 0,
            alignItems: 'flex-end',
            flexWrap: 'wrap-reverse',
          }}
          className="cm-k-notification-group"
        >
          <Fade enter exit>
            {isNotification && (
              <Notification
                className="cm-k-notification"
                closable={false}
                type={{ style: notificationType, icon: true }}
                onClose={() => {
                  isNotification = false
                }}
              >
                <span>{i18n.t(notificationMessage)}</span>
              </Notification>
            )}
          </Fade>
        </NotificationGroup>
      </div>
    )
  }
}

export default KendoNotification
